/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

export const columns: TableColumn[] = [
    {
        Header: 'tableCommon.sl_no',
        accessor: 'slno',
      },
      {
        Header: 'tableCommon.batch_code',
        accessor: 'batch_number',
      },
      {
        Header: 'tableCommon.lot_code',
        accessor: 'lot_code',
      },
      {
        Header: 'visualInspectionTest.tableColumns.totalPlates',
        accessor: 'total_plates',
      },
      {
        Header: 'visualInspectionTest.tableColumns.passedPlates',
        accessor: 'passed_plates',
      },
      {
        Header: 'visualInspectionTest.tableColumns.failedPlates',
        accessor: 'failed_plates',
      },
      {
        Header: 'visualInspectionTest.tableColumns.operatorName',
        accessor: 'operator_name',
      },
      // {
      //   Header: 'Operator ID',
      //   accessor: 'operator_id',
      // },
      {
        Header: 'visualInspectionTest.tableColumns.operatorCode',
        accessor: 'operator_code',
      },
      {
        Header: 'visualInspectionTest.tableColumns.date',
        accessor: 'date',
      },
      {
        Header: 'visualInspectionTest.tableColumns.status',
        accessor: 'status',
      },
      {
        Header: 'visualInspectionTest.tableColumns.inspectionReason',
        accessor: 'reason',
      },
      {
        Header: 'visualInspectionTest.tableColumns.remarks',
        accessor: 'remarks',
      },
    
  ];


export const columnsModalTable: TableColumn[] = [
    {
        Header: 'tableCommon.sl_no',
        accessor: 'slno',
      },
      {
        Header: 'tableCommon.batch_code',
        accessor: 'batch_number',
      },
      {
        Header: 'tableCommon.lot_code',
        accessor: 'lot_code',
      },
      {
        Header: 'visualInspectionTest.tableColumns.plateCount',
        accessor: 'plate_count',
      },
      {
        Header: 'visualInspectionTest.tableColumns.passCount',
        accessor: 'lot_pass_count',
      },
      {
        Header: 'visualInspectionTest.tableColumns.failedPlates',
        accessor: 'failed_plates',
      }
]

  
interface TableColumn {
    Header: string;
    accessor: string;
}